import { defineComponent as _defineComponent } from 'vue'
import { computed, ref, watch } from "@nuxtjs/composition-api";
import { useVModel } from "@vueuse/core";

interface Option {
  year: number;
  month: number;
  label: string;
  value: string;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'stock-calendar-header',
  props: {
    months: { default: () => [] },
    value: { default: "" }
  },
  emits: ["input", "change"],
  setup(__props: any, { emit }: { emit: ({
  (name: "input", value: string): void;
  (name: "change", value: string): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { months: Array<Option>, value: string }





const modelValue = useVModel(props, "value", emit, {
  eventName: "input",
});


// watch(() => props.value, value => {
  // ;
  // selectedIndex.value = index > -1 ? index : 0;
// })


const selectedIndex = computed(() => {
  return  props.months.findIndex(month => month.value === props.value)
});

const selectedValue = computed(() => {
  return props.months[selectedIndex.value];
});




const isOpen = ref(false);

const onItemClick = (option: Option, index: number) => {
  if (option.value === props.value) {
    return;
  }
  // selectedIndex.value = index;
  modelValue.value = option.value;

  emit("change", option.value);

  isOpen.value = false;
};

const onStep = (step: number) => {
  let index = selectedIndex.value + step;
  let value = props.months[index].value;
  modelValue.value = value
  emit("change",value);
}

return { __sfc: true,props, emit, modelValue, selectedIndex, selectedValue, isOpen, onItemClick, onStep }
}

})